
import React from 'react';
import { cn } from '@/lib/utils';

interface GlassCardProps extends React.HTMLAttributes<HTMLDivElement> {
  children: React.ReactNode;
  className?: string;
  hoverEffect?: boolean;
}

const GlassCard: React.FC<GlassCardProps> = ({ 
  children, 
  className, 
  hoverEffect = false,
  ...props 
}) => {
  return (
    <div 
      className={cn(
        "glass-effect rounded-xl p-6",
        hoverEffect && "transition-all duration-300 hover:shadow-hover hover:-translate-y-1 hover:border-brand-pink/30",
        className
      )} 
      {...props}
    >
      {children}
    </div>
  );
};

export default GlassCard;
